module.exports = __webpack_public_path__ + "img/control_de_calidad_9-16_810.eb2dffb8.jpg";